module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('common-tooltip-inner', {
    attrs: {
      "visible": _vm.popupVisible,
      "title": _vm.basedataGetName('SysTip', _vm.tipCode)
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tishi1",
    class: _vm.isView ? 'view' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleShowTooltip($event)
      }
    }
  })])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f046f23c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f046f23c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonTooltip.vue
// module id = 767
// module chunks = 7